import assetIcChevronLeft from './ic-chevron-left.svg';
export enum BackButtonIconName {
  Back = 'Back',
}

export const backButtonIconAssets: {
  [key in BackButtonIconName]: string;
} = {
  [BackButtonIconName.Back]: assetIcChevronLeft,
};
